import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const AlertCircle: FC<Props> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('w-[16px] h-[16px]', className)}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_522_304)">
      <path
        d="M8.00016 5.33333V8M8.00016 10.6667H8.00683M14.6668 8C14.6668 11.6819 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.6819 1.3335 8C1.3335 4.3181 4.31826 1.33333 8.00016 1.33333C11.6821 1.33333 14.6668 4.3181 14.6668 8Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_522_304">
        <rect width="16" height="16" fill="none" />
      </clipPath>
    </defs>
  </svg>
);

export default AlertCircle;
